import { OperationButton, OperationType, Space } from '../../atoms'

export interface IconButtonProps {
  'data-testid'?: string
  disabled?: boolean
  icon: React.ReactNode
  iconPosition: 'left' | 'right'
  id?: string
  isLoading?: boolean
  onClick?: () => void
  operationType: OperationType
  text: string
  type?: 'button' | 'submit' | 'reset'
  width?: string
}

const IconButton = ({
  disabled,
  icon,
  iconPosition,
  id,
  isLoading,
  onClick,
  operationType,
  text,
  width,
  ...props
}: IconButtonProps) => (
  <OperationButton
    data-testid={props['data-testid']}
    id={id}
    isDisabled={disabled}
    isLoading={isLoading}
    operationType={operationType}
    width={width}
    onClick={onClick}
  >
    <Space isflex alignContent="center" alignItems="center" margin="auto">
      {iconPosition && iconPosition === 'left' && icon}
      <Space mx={2}>{text}</Space>
      {iconPosition && iconPosition === 'right' && icon}
    </Space>
  </OperationButton>
)

export default IconButton
